import { render, staticRenderFns } from "./mv.vue?vue&type=template&id=6d858070&scoped=true"
import script from "./mv.vue?vue&type=script&lang=js"
export * from "./mv.vue?vue&type=script&lang=js"
import style0 from "./mv.vue?vue&type=style&index=0&id=6d858070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d858070",
  null
  
)

export default component.exports